import React, { useState } from 'react';
import { showToast } from '../utils/ShowToast';

const CHOCOWI_WEBSITE_URL = process.env.REACT_APP_Website_URL || 'https://chocowi.com';

const emailTemplates = [
    {
        id: 1,
        name: "Seller Marketing Template",
        description: "Marketing template for sellers — cakes, pastries, gifts",
        image: "https://res.cloudinary.com/drcuo3fya/image/upload/v1773733613/Group_1000002602_ppimon.png",
        code: `<div style="width: 100%; max-width: 900px; margin: 0 auto;">
    <a href="${CHOCOWI_WEBSITE_URL}"><img src="https://res.cloudinary.com/drcuo3fya/image/upload/v1773733613/Group_1000002602_ppimon.png" alt="Start Selling on Chocowi" width="100%"></a>
</div>`
    },
    {
        id: 2,
        name: "Buyers & Sellers Template",
        description: "Marketing template for both buyers and sellers",
        image: "https://res.cloudinary.com/drcuo3fya/image/upload/v1773733608/Group_1000002603_xwqhpg.png",
        code: `<div style="width: 100%; max-width: 900px; margin: 0 auto;">
    <a href="${CHOCOWI_WEBSITE_URL}"><img src="https://res.cloudinary.com/drcuo3fya/image/upload/v1773733608/Group_1000002603_xwqhpg.png" alt="Join Chocowi" width="100%"></a>
</div>`
    }
];

function AdminEmailTemplates() {
    const [previewTemplate, setPreviewTemplate] = useState(null);

    const handleDownload = async (template) => {
        try {
            const hdImageUrl = template.image.replace('/upload/', '/upload/q_auto,f_png,w_1920/');
            const response = await fetch(hdImageUrl);
            const blob = await response.blob();
            const element = document.createElement("a");
            element.href = URL.createObjectURL(blob);
            element.download = `${template.name.toLowerCase().replace(/\s+/g, '-')}.png`;
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
            URL.revokeObjectURL(element.href);
            showToast('Template image downloaded successfully!', 'success');
        } catch (error) {
            showToast('Failed to download template image', 'error');
        }
    };

    const copyToClipboard = async (template) => {
        try {
            await navigator.clipboard.writeText(template.code);
            showToast('Template code copied to clipboard!', 'success');
        } catch (err) {
            showToast('Failed to copy template code', 'error');
        }
    };

    return (
        <div className="templatesSection">
            <h3 className="secondaryHeading">Email <span>Templates</span></h3>

            <div className="templatesGrid">
                {emailTemplates.map((template) => (
                    <div key={template.id} className="templateCard">
                        <div className="templateImageContainer">
                            <img
                                src={template.image}
                                alt={template.name}
                                className="templateImage"
                            />
                            <div className="templateOverlay">
                                <h4 className="templateName">{template.name}</h4>
                                <p className="templateDescription">{template.description}</p>
                                <div className="templateActions">
                                    <button
                                        className="templateBtn previewBtn"
                                        onClick={() => setPreviewTemplate(template)}
                                    >
                                        Preview
                                    </button>
                                    <button
                                        className="templateBtn copyBtn"
                                        onClick={() => copyToClipboard(template)}
                                    >
                                        Copy Code
                                    </button>
                                    <button
                                        className="templateBtn downloadBtn"
                                        onClick={() => handleDownload(template)}
                                    >
                                        Download
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {previewTemplate && (
                <div className="modalOverlay" onClick={() => setPreviewTemplate(null)}>
                    <div className="modalContent" onClick={(e) => e.stopPropagation()}>
                        <div className="modalHeader">
                            <h3 className="secondaryHeading">{previewTemplate.name}</h3>
                            <div className="modalActions">
                                <button
                                    className="templateBtn copyBtn"
                                    onClick={() => copyToClipboard(previewTemplate)}
                                >
                                    Copy Code
                                </button>
                                <button
                                    className="modalCloseBtn"
                                    onClick={() => setPreviewTemplate(null)}
                                >
                                    ✕
                                </button>
                            </div>
                        </div>
                        <div className="modalBody">
                            <div dangerouslySetInnerHTML={{ __html: previewTemplate.code }} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AdminEmailTemplates;
